import { render, staticRenderFns } from "./c2LowFrequency.vue?vue&type=template&id=38a68f0a&scoped=true&"
import script from "./c2LowFrequency.vue?vue&type=script&lang=js&"
export * from "./c2LowFrequency.vue?vue&type=script&lang=js&"
import style0 from "./c2LowFrequency.vue?vue&type=style&index=0&id=38a68f0a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a68f0a",
  null
  
)

export default component.exports